import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { Link } from "react-router-dom";
import apiService from "../../services/api";

function CategoryTwo() {
    const swiperRef = useRef(null);
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);

    // Fallback categories if API fails
    const fallbackCategories = [
        { id: 1, name: "Safari Adventures", slug: "safari-adventures", image_url: "/assets/img/category/category_1_1.jpg" },
        { id: 2, name: "Mountain Climbing", slug: "mountain-climbing", image_url: "/assets/img/category/category_1_2.jpg" },
        { id: 3, name: "Cultural Tours", slug: "cultural-tours", image_url: "/assets/img/category/category_1_3.jpg" },
        { id: 4, name: "Beach Holidays", slug: "beach-holidays", image_url: "/assets/img/category/category_1_4.jpg" },
    ];

    // Fetch tour categories from API
    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await apiService.getTourCategories();
                if (response && response.results && response.results.length > 0) {
                    // Map API response to component format and add fallback images
                    const mappedCategories = response.results.map((category, index) => ({
                        ...category,
                        title: category.name, // Map name to title for consistency
                        img: category.image_url || `/assets/img/category/category_1_${(index % 5) + 1}.jpg`
                    }));
                    setCategories(mappedCategories);
                } else {
                    // Map fallback categories to include title property
                    const mappedFallback = fallbackCategories.map(category => ({
                        ...category,
                        title: category.name,
                        img: category.image_url
                    }));
                    setCategories(mappedFallback);
                }
            } catch (error) {
                console.error('Error fetching tour categories:', error);
                // Map fallback categories to include title property
                const mappedFallback = fallbackCategories.map(category => ({
                    ...category,
                    title: category.name,
                    img: category.image_url
                }));
                setCategories(mappedFallback);
            } finally {
                setLoading(false);
            }
        };

        fetchCategories();
    }, []);

    useEffect(() => {
        if (!swiperRef.current) return;

        const swiperInstance = swiperRef.current.swiper;

        // ✅ Start autoplay properly
        if (swiperInstance && swiperInstance.autoplay) {
            swiperInstance.autoplay.start();
        }

        // ✅ Custom pagination with numbers
        if (swiperInstance.pagination) {
            swiperInstance.pagination.renderBullet = function (index, className) {
                let formattedNumber = index + 1 < 10 ? "0" + (index + 1) : index + 1;
                return `<span class="${className} number">${formattedNumber}</span>`;
            };
            swiperInstance.pagination.init();
            swiperInstance.pagination.update();
        }
        const multiplier = { translate: 0.1, rotate: 0.0 };

        const calculateWheel = () => {
            const slides = document.querySelectorAll(".single2");
            slides.forEach((slide) => {
                const rect = slide.getBoundingClientRect();
                const r = window.innerWidth * 0.5 - (rect.x + rect.width * 0.5);
                let ty = Math.abs(r) * multiplier.translate - rect.width * multiplier.translate;
                if (ty < 0) ty = 0;

                const transformOrigin = r < 0 ? "left top" : "right top";
                slide.style.transform = `translate(0, ${ty}px) rotate(${-r * multiplier.rotate}deg)`;
                slide.style.transformOrigin = transformOrigin;
            });
        };

        const raf = () => {
            requestAnimationFrame(raf);
            calculateWheel();
        };

        raf();

        return () => cancelAnimationFrame(raf); // Cleanup on unmount
    }, []);

    if (loading) {
        return (
            <section className="category-area2 bg-top-center">
                <div className="container th-container">
                    <div className="title-area text-center">
                        <span className="sub-title">Wonderful Place For You</span>
                        <h2 className="sec-title">Tour Categories</h2>
                    </div>
                    <div className="text-center py-5">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading categories...</span>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    return (
        <section className="category-area2 bg-top-center">
            <div className="container th-container">
                <div className="title-area text-center">
                    <span className="sub-title">Wonderful Place For You</span>
                    <h2 className="sec-title">Tour Categories</h2>
                </div>

                <Swiper
                    ref={swiperRef}
                    modules={[Pagination]}
                    spaceBetween={60}
                    slidesPerView={5}
                    centeredSlides={true}
                    loop={true}
                    grabCursor={true}
                    pagination={{ clickable: true, el: ".swiper-pagination", type: "bullets" }}
                    breakpoints={{
                        300: { slidesPerView: 1, spaceBetween: 30 },
                        600: { slidesPerView: 2, spaceBetween: 30 },
                        768: { slidesPerView: 3, spaceBetween: 30 },
                        1024: { slidesPerView: 4, spaceBetween: 40 },
                        1280: { slidesPerView: 5, spaceBetween: 60 },
                    }}
                >
                    {categories.map((category) => (
                        <SwiperSlide key={category.id}>
                            <div className="category-card single2">
                                <div className="box-img global-img">
                                    <img src={category.img} alt={category.title} />
                                </div>
                                <h3 className="box-title">
                                    <Link to={`/categories/${category.slug}`}>{category.title}</Link>
                                </h3>
                                <Link className="line-btn" to={`/categories/${category.slug}`}>
                                    See more
                                </Link>
                            </div>
                        </SwiperSlide>
                    ))}
                <div className="swiper-pagination position-relative"></div>
                </Swiper>
            </div>
        </section>
    );
}

export default CategoryTwo;
